/**
 * User types and schemas for authentication
 */

import * as S from "@effect/schema/Schema";

/**
 * User entity schema
 */
export const UserSchema = S.Struct({
  id: S.String,
  email: S.String,
  googleId: S.String,
  name: S.NullOr(S.String),
  picture: S.NullOr(S.String),
  createdAt: S.Date,
  updatedAt: S.Date,
});

/**
 * User type
 */
export type User = S.Schema.Type<typeof UserSchema>;

/**
 * User response schema (for API responses)
 */
export const UserResponseSchema = S.Struct({
  id: S.String,
  email: S.String,
  name: S.NullOr(S.String),
  picture: S.NullOr(S.String),
});

/**
 * User response type (excludes sensitive fields)
 */
export type UserResponse = S.Schema.Type<typeof UserResponseSchema>;

/**
 * Auth state schema
 */
export const AuthStateSchema = S.Struct({
  isAuthenticated: S.Boolean,
  user: S.NullOr(UserResponseSchema),
});

/**
 * Auth state type
 */
export type AuthState = S.Schema.Type<typeof AuthStateSchema>;

/**
 * Convert User entity to UserResponse
 */
export const toUserResponse = (user: User): UserResponse => ({
  id: user.id,
  email: user.email,
  name: user.name,
  picture: user.picture,
});
